import { Component, Input, OnInit } from '@angular/core';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { ModalService } from 'src/app/core/services/modal.service';
import { FarmDeviceDetailItem } from '../../models/farm-device.model';

@Component({
  selector: 'app-device-info-update',
  templateUrl: './device-info-update.component.html',
  styleUrls: ['./device-info-update.component.scss'],
})
export class DeviceInfoUpdateComponent extends BaseModal implements OnInit {
  @Input()  detailItem: FarmDeviceDetailItem;
  
  constructor(private modalService: ModalService) {
    super()
    super._modalService = modalService
  }

  ngOnInit() { }

}
